import { ArrowLeftIcon, CloseIcon } from '@/assets/images';
import PropTypes from 'prop-types';
import './SidePanelGlobal.scss';

const SidePanelGlobal = ({ isOpen, title, body, showBack, onBack, onClose }) => {
   const navAction = showBack
      ? { handler: onBack, label: 'Go back', Icon: ArrowLeftIcon, iconClass: 'back-arrow-white' }
      : { handler: onClose, label: 'Close panel', Icon: CloseIcon, iconClass: '' };

   return (
      <aside
         className={`side-panel-global ct-flex ct-fcol${showBack ? ' has-navigation' : ''} ${isOpen ? 'open' : ''}`}
         aria-labelledby="panel-title"
      >
         <div className="header ct-flex ct-aiCenter ct-gap10">
            <button
               type="button"
               className="header-icon ct-flexCenter ct-cursor"
               onClick={navAction.handler}
               aria-label={navAction.label}
            >
               <navAction.Icon className={navAction.iconClass} />
            </button>
            <h2 id="panel-title" className="title">
               {title}
            </h2>
         </div>

         <div className="content ct-flex1 ct-scroll">{body}</div>
      </aside>
   );
};

SidePanelGlobal.propTypes = {
   isOpen: PropTypes.bool.isRequired,
   title: PropTypes.string,
   body: PropTypes.node,
   showBack: PropTypes.bool,
   onBack: PropTypes.func,
   onClose: PropTypes.func,
};

export default SidePanelGlobal;
